/* eslint-disable camelcase */
import { DateTime } from 'luxon';
import { MeetingSnapshot } from '../models/Meeting';
import api from './api';
import { getBackVersion } from '../config';

const createMeetingAvailability = (
    availableFrom: DateTime,
    availableTo: DateTime,
    subject: string
): Promise<MeetingSnapshot> => {
    return api.request({
        method: 'POST',
        url: `${getBackVersion()}/meetings`,
        data: {
            available_from: availableFrom.toISO(),
            available_to: availableTo.toISO(),
            subject: subject,
        },
    });
};

export default { createMeetingAvailability };
